import memoize from 'lodash/memoize'

export const splitFilter = (index: number) =>
  memoize((filter: string) => {
    const splitFilter = filter.split(':')
    return splitFilter ? splitFilter[index] : filter
  })

const filterToAbbreviatedYear = (filter: string) => `'${filter.split(':')[0].slice(2,4)} `

export const yearsString = (filters?: string[], maxCount?: number) => {
  if (!filters || filters.length === maxCount) {
    return ''
  }
  if (filters.length === 1) {
    return `${filterToAbbreviatedYear(filters[0])} `
  }
  const filterYears = filters.map(filter => filter.split(':')[0])
  const sortedYears = filterYears.sort()
  return `${filterToAbbreviatedYear(sortedYears[0])}-${filterToAbbreviatedYear(
    sortedYears[sortedYears.length - 1]
  )}`
}
